import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "../utils/AuthContext.tsx";
import { useContactByIdentity } from "../utils/Api.ts";

interface ContactLabelProps {
  displayName: string;
  identity: string;
}

const ContactThing: React.FC<{ identity: string }> = ({ identity }) => {
  const { token } = useAuth();
  const { data: contact } = useContactByIdentity(identity, token ?? undefined);

  return (
    <div className="rounded-sm p-2">
      {!contact && <span className="text-sm font-bold">{identity}</span>}
      {contact && (
        <>
          <div className="text-sm font-bold">{contact.fullName}</div>
          <div className="text-sm text-muted-foreground">{contact.title}</div>
          <div className="text-sm text-muted-foreground">{contact.org}</div>
          <div className="text-sm text-muted-foreground">{contact.emails.length && contact.emails[0]}</div>
          <div className="text-sm text-muted-foreground">{contact.phones.length && contact.phones[0]}</div>
        </>
      )}
    </div>
  );
};

const ContactLabel: React.FC<ContactLabelProps> = ({ displayName, identity }) => {
  const { token } = useAuth();
  const { data: contact } = useContactByIdentity(identity, token ?? undefined);

  return (
    <TooltipProvider>
      <Tooltip delayDuration={200}>
        <TooltipTrigger>
          <span className="text-sm text-muted-foreground hover:underline ">
            {(contact && contact.fullName) ?? displayName}
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <ContactThing identity={identity} />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { ContactLabel, ContactThing };
